import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useRemoveRequirement, useResetRequirementErrors } from '../../hooks/requirement';
import { useQueryStateContext } from '../../contexts';

export const RemoveButton = () => {
  const { RemoveRequirementButton } = useVisualComponentsContext();
  const removeRequirement = useRemoveRequirement();
  const resetRequirementErrors = useResetRequirementErrors();
  const { isReadOnly = false } = useQueryStateContext();

  if (isReadOnly) return null;

  return (
    <RemoveRequirementButton
      isDisabled={isReadOnly}
      onClick={() => {
        removeRequirement();
        resetRequirementErrors();
      }}
    />
  );
};
